import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GoogleMap from 'react-google-map';

import withGoogleMaps from 'client/helpers/withGoogleMaps';
import { defaultPolygonOptions } from 'client/constants/mapOptions';

@withGoogleMaps
class SrAgentLeadMapView extends Component {
  static propTypes = {
    lead: PropTypes.object.isRequired,
    googleMaps: PropTypes.object,
  };

  _onLoadedMap = (googleMaps, map) => {
    const { lead: { renter } } = this.props;
    const bounds = new googleMaps.LatLngBounds();

    renter.searchFilters.area.forEach((coord) => {
      bounds.extend(new googleMaps.LatLng(coord[1], coord[0]));
    });

    map.setCenter(bounds.getCenter());

    this.polygon = new googleMaps.Polygon({
      paths: renter.searchFilters.area.map((coord) => ({
        lng: coord[0],
        lat: coord[1],
      })),
      ...defaultPolygonOptions,
    });

    this.polygon.setMap(map);
  }

  render() {
    const { googleMaps } = this.props;

    return (
      <div className='mapContainerPreview'>
        <div className='mapDimensions'>
          <GoogleMap
            className='map'
            googleMaps={googleMaps}
            center={{
              lat: 30.170061,
              lng: -97.749222,
            }}
            zoom={10}
            disableDefaultUI
            gestureHandling='cooperative'
            onLoaded={this._onLoadedMap}
          />
        </div>
      </div>
    );
  }
}

SrAgentLeadMapView.displayName = 'SrAgentLeadMapView';

export default SrAgentLeadMapView;
